// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g-root .dl-resizer {
  background: var(--g-color-line-generic);
  z-index: 4;
  box-sizing: border-box;
  background-clip: padding-box;
  flex-shrink: 0;
  transition: border 0.15s linear;
}
.g-root .dl-resizer.horizontal {
  height: 9px;
  margin: -4px 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  cursor: row-resize;
  width: 100%;
}
.g-root .dl-resizer.horizontal:hover {
  border-top: 4px solid var(--g-color-base-simple-hover);
  border-bottom: 4px solid var(--g-color-base-simple-hover);
}
.g-root .dl-resizer.vertical {
  width: 9px;
  margin: 0 -4px;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  cursor: col-resize;
}
.g-root .dl-resizer.vertical:hover {
  border-left: 4px solid var(--g-color-base-simple-hover);
  border-right: 4px solid var(--g-color-base-simple-hover);
}
.g-root .dl-resizer.disabled {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/ui/styles/split-pane-resizer.scss"],"names":[],"mappings":"AACI;EACI,uCAAA;EACA,UAAA;EACA,sBAAA;EACA,4BAAA;EACA,cAAA;EACA,+BAAA;AAAR;AAGI;EACI,WAAA;EACA,cAAA;EACA,iCAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;AADR;AAII;EACI,sDAAA;EACA,yDAAA;AAFR;AAKI;EACI,UAAA;EACA,cAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;AAHR;AAMI;EACI,uDAAA;EACA,wDAAA;AAJR;AAOI;EACI,aAAA;AALR","sourcesContent":[".g-root .dl-resizer {\n  background: var(--g-color-line-generic);\n  z-index: 4;\n  box-sizing: border-box;\n  background-clip: padding-box;\n  flex-shrink: 0;\n  transition: border 0.15s linear;\n}\n.g-root .dl-resizer.horizontal {\n  height: 9px;\n  margin: -4px 0;\n  border-top: 4px solid transparent;\n  border-bottom: 4px solid transparent;\n  cursor: row-resize;\n  width: 100%;\n}\n.g-root .dl-resizer.horizontal:hover {\n  border-top: 4px solid var(--g-color-base-simple-hover);\n  border-bottom: 4px solid var(--g-color-base-simple-hover);\n}\n.g-root .dl-resizer.vertical {\n  width: 9px;\n  margin: 0 -4px;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  cursor: col-resize;\n}\n.g-root .dl-resizer.vertical:hover {\n  border-left: 4px solid var(--g-color-base-simple-hover);\n  border-right: 4px solid var(--g-color-base-simple-hover);\n}\n.g-root .dl-resizer.disabled {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
